import * as actions from './actions';
import update from 'react/lib/update';

const initState = {
    loadingCustomPricelists: false,
    customPricelists: [],
    search: '',
    selected: 'default',
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.SET_CUSTOMPRICELISTS_LOADING_LIST:
            return update(state, {
                loadingCustomPricelists: {
                    $set: action.status,
                }
            })
        case actions.GET_CUSTOM_PRICELISTS_SUCCESS_LIST:
            return update(state, {
                customPricelists: {
                    $set: action.customPricelists
                }
            });
        case actions.SET_SEARCH_TERM:
            return update(state, {
                search: {
                    $set: action.search
                }
            });
        case actions.SET_SELECTED_PRICELIST:
            return update(state, {
                selected: {
                    $set: action.pricelistId
                }
            });
        case 'KILL_WORKPLACE':
            return initState
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/App/PricelistsList/reducer.js